import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'
import { DaoProjectsSearchParams, DaoPtoProjectItemType, ResponsePagingType } from 'Modules'

import { AppAdmin } from 'api/app-admin'

/**
 * DAO Voting PTO project list (GET /admin/dao-voting/pto-projects).
 * Keyed by params; previous page data is kept while the next page loads.
 */
export const daoPtoProjectsQueryOptions = (params: DaoProjectsSearchParams) =>
  queryOptions({
    queryKey: ['daoVoting', 'ptoProjects', params],
    queryFn: async () => {
      const res = await AppAdmin.getDaoVotingProjects(params)
      return (res.data?.data || {}) as ResponsePagingType<DaoPtoProjectItemType>
    },
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  })

export const useDaoPtoProjects = (params: DaoProjectsSearchParams) => {
  const query = useQuery(daoPtoProjectsQueryOptions(params))

  return {
    projects: query.data?.results || [],
    totalResults: query.data?.totalResults || 0,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    refetch: query.refetch,
  }
}
